import { render } from "./ModalNuovoOrdine.vue?vue&type=template&id=62986a4c&scoped=true"
import script from "./ModalNuovoOrdine.vue?vue&type=script&lang=js"
export * from "./ModalNuovoOrdine.vue?vue&type=script&lang=js"

import "./ModalNuovoOrdine.vue?vue&type=style&index=0&id=62986a4c&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1769522087380908112/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62986a4c"]])

export default __exports__